@if (userType === 'passenger') {
  <div class="trip-card block-background">
    <div class="date-status">
      <span class="date main-text-color">{{passengerReq?.created_at | locTz : 'DD.MM.yy HH:mm'}}</span>
      <mat-icon class="status"
                [ngClass]="{'done-color': passengerReq?.status === 'completed', 'alert-color': passengerReq?.status === 'canceled'}"
      >{{passengerReq?.status === 'completed' ? 'done' : 'do_not_disturb_alt'}}</mat-icon>
    </div>
    <div class="route">
      <div class="point-list">
        <ul class="note-container main-text-color">
          @for (address of passengerReq.waypoints; track address) {
            <li class="note note-view">{{address.name}}</li>
          }
        </ul>
      </div>
    </div>
    <div class="paid">
      <div class="paid-type-sum">
        <mat-icon class="paid-type icon-color">
          {{passengerReq.payment_type === 'cash' ? 'account_balance_wallet' : 'wallet'}}
        </mat-icon>
        <span class="icon-color">{{passengerReq.fare?.amount | currency: 'UAH': 'symbol-narrow' : '1.0': 'uk'}}</span>
      </div>
    </div>
  </div>
} @else if (userType === 'driver') {
  <div class="trip-card block-background">
    <div class="date-status">
      <span class="date main-text-color">{{driverReq?.created_at | locTz : 'DD.MM.yy HH:mm'}}</span>
      <mat-icon class="status"
                [ngClass]="{'done-color': driverReq?.status === 'completed', 'alert-color': driverReq?.status === 'canceled'}"
      >{{driverReq?.status === 'completed' ? 'done' : 'do_not_disturb_alt'}}</mat-icon>
    </div>
    <div class="route">
      <div class="point-list">
        <ul class="note-container main-text-color">
          @for (address of (driverReq?.waypoints || driverReq?.geography?.waypoints); track address) {
            <li class="note note-view">{{address.name}}</li>
          }
        </ul>
      </div>
    </div>
<!--    <div class="paid">-->
<!--      <div class="paid-type-sum">-->
<!--        @if (driverReq?.receipt) {-->
<!--          <mat-icon class="paid-type icon-color">-->
<!--            {{driverReq.receipt?.payment_type === 'cash' ? 'account_balance_wallet' : 'wallet'}}-->
<!--          </mat-icon>-->
<!--          <span class="icon-color">{{driverReq.receipt?.amount | currency: 'UAH': 'symbol-narrow' : '1.0': 'uk'}}</span>-->
<!--        }-->
<!--      </div>-->
<!--    </div>-->
  </div>
}
